"use client"

import { useConfigParams } from "@/hooks/use-config-params"
import { trackAnalyticsEvent } from "@/lib/analytics"
import { ReactNode } from "react"

export function PdvBannerRedirect({ children }: { children: ReactNode }) {
  const { channel } = useConfigParams()
  const cancelCallbackUrl = window.location.href

  const getRedirectUrl = () => {
    const url = new URL(`${window.APP_REDIRECT_REG}/registrazione-pdv`)
    url.searchParams.set("siteid", channel.toString())
    url.searchParams.set("cancelcallbackurl", cancelCallbackUrl)
    return url.toString()
  }

  const handleClick = () => {
    trackAnalyticsEvent({
      event: "link_click",
      event_name: "nav_click",
      conversion_pagename: "login",
      position: "login",
      cta_label: "attivalo qui",
    })
  }

  return (
    <a href={getRedirectUrl()} onClick={handleClick}>
      {children}
    </a>
  )
}
